export const en = {
    translation: {
        common: {
            account: 'Account',
            loading: 'Loading...',
            cancel: 'Cancel',
            close: 'Close',
            verifyCode: 'Verify code',
            disable: 'Disable',
            setup: 'Set up',
            retry: 'Retry',
        },
        shell: {
            pageTitle: '{{tenantName}} Account',
            securityNav: 'Security',
            navigation: 'Account navigation',
            signOut: 'Sign out',
            tenantSpace: 'Tenant account',
        },
        states: {
            missingTenantTitle: 'Missing tenant path',
            missingTenantDescription: 'This account app expects a URL in the shape of /t/:tenantSlug.',
            disabledTitle: 'Account management is disabled',
            disabledDescription: 'This tenant has not enabled the self-service account experience yet.',
            redirectingDescription: 'Redirecting to sign in...',
            redirectingBody: 'You need an active session to manage this account.',
            notFoundTitle: 'Page not found',
            notFoundDescription: 'The page you are looking for does not exist.',
            fatalErrorTitle: 'Service unavailable',
        },
        security: {
            title: 'Sign-in and security',
            description: 'Manage your sign-in methods and account security.',
            local: {
                title: 'Password and verification',
                externalCredentials: {
                    title: 'Managed by your sign-in provider',
                    description:
                        'Your password and sign-in verification methods are controlled by the provider you use to access this account.',
                },
                status: {
                    enabled: 'Enabled',
                    notSetUp: 'Not set up',
                },
                password: {
                    title: 'Password',
                    description: 'Change your sign-in password.',
                    unavailable: 'Password sign-in is not available for this account.',
                    changeAction: 'Change password',
                    dialog: {
                        title: 'Change password',
                        description: 'Choose a new password for future sign-ins.',
                        newPassword: 'New password',
                        confirmPassword: 'Confirm new password',
                        confirmPasswordMismatch: 'Passwords do not match yet.',
                        submit: 'Update password',
                    },
                    requirements: {
                        title: 'Requirements',
                        length: 'At least {{minLength}} characters',
                        lower: 'One lowercase letter',
                        upper: 'One uppercase letter',
                        digit: 'One digit',
                        special: 'One special character (e.g. - + _ ! @ # $ % ^ & * . , ? < > =)',
                        noRepeat: 'No more than 2 identical characters in a row',
                    },
                    messages: {
                        updated: 'Your password has been updated.',
                        updateError: 'Unable to change the password.',
                    },
                },
                authenticator: {
                    title: 'Authenticator app',
                    description: 'Verification codes from an app.',
                    dialog: {
                        setup: {
                            title: 'Set up authenticator app',
                            description:
                                'Scan this QR code with your authenticator app. If scanning is not possible, you can enter the setup key manually.',
                            codeLabel: 'Enter the 6-digit code',
                            copy: 'Copy',
                            copied: 'Copied',
                            submit: 'Verify code',
                        },
                        manage: {
                            description:
                                'Your account uses verification codes from your authenticator app when signing in.',
                        },
                        disable: {
                            title: 'Disable authenticator app?',
                            description:
                                'This verification method will be removed from your account. You can set it up again later.',
                            action: 'Disable authenticator app',
                        },
                    },
                    messages: {
                        setupError: 'Unable to start authenticator setup.',
                        enabled: 'Authenticator app has been enabled.',
                        disabled: 'Authenticator app has been disabled.',
                        verifyError: 'Unable to verify the authenticator code.',
                        disableError: 'Unable to disable this verification method. Please try again.',
                    },
                },
                email: {
                    title: 'Email codes',
                    description: 'Verification codes by email.',
                    dialog: {
                        setup: {
                            title: 'Set up email codes',
                            description: 'Enter the verification code we sent to your primary email address.',
                            codeLabel: 'Verification code',
                            resend: 'Send new code',
                        },
                        manage: {
                            description: 'Your account uses verification codes sent to your email when signing in.',
                        },
                        disable: {
                            title: 'Disable email codes?',
                            description:
                                'This verification method will be removed from your account. You can set it up again later.',
                            action: 'Disable email codes',
                        },
                    },
                    messages: {
                        setupError: 'Unable to set up email codes.',
                        verified: 'Email codes have been enabled.',
                        disabled: 'Email codes have been disabled.',
                        verifyError: 'Unable to verify the email code.',
                        disableError: 'Unable to disable this verification method. Please try again.',
                    },
                },
            },
            connections: {
                title: 'Connected accounts',
                description: 'Connect another account to use it for signing in.',
                connectProvider: 'Connect {{provider}}',
                connecting: 'Connecting...',
                connected: 'Connected',
                unavailable: 'Sign-in with this provider is currently unavailable.',
                providers: {
                    google: 'Google',
                    microsoft: 'Microsoft',
                },
                messages: {
                    connected: 'Your {{provider}} account has been connected.',
                    alreadyConnected: 'This {{provider}} account is already connected.',
                    providerConflict: 'You already have a connected {{provider}} account.',
                    accountInUse: 'This {{provider}} account is already linked to another user.',
                    providerUnavailable: 'Sign-in with {{provider}} is no longer available.',
                    failed: 'Unable to connect the account. Please try again.',
                },
            },
        },
        messages: {
            loadError: 'Unable to load the account experience.',
            signOutSuccess: 'You have been signed out of the account app.',
            signOutError: 'Unable to sign out right now.',
        },
    },
}
